module.exports = __webpack_public_path__ + "media/images/iconSettings__errorRed--dark-93594b885f2ddd8b9143ec46edffc3f9.png";